export default __webpack_public_path__ + "static/media/dna-bg.ee54f2f6.webp";